export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_1502_INDIVIDUAL': 'Individual',
    '_7471_TEAM': 'Team',
    '_1504_TEAM___SUBORDINATES': 'Team & Subordinates',
    '_9684_FROM': 'From',
    '_9685__TO': 'To',
    '_657_SELECT_A_USER': 'Select a User',
    '_10014_SELECT_DATE_RANGE': 'Select Date Range',
    '_710_SEARCH': 'Search',
    '_97_SEARCH_RESULTS': 'Search Results',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_72_USERNAME': 'Username',
    '_9999_EVENT_DATE': 'Event Date',
    '_10001_EVALUATION_DATE': 'Evaluation Date',
    '_752_SCORE': 'Score',
    '_9998_EVALUATION_NAME': 'Evaluation Name',
    '_127_STATUS': 'Status',
    '_9476_DRAFT': 'Draft',
    '_9113_PUBLISHED': 'Published',
    '_99_SELECT': 'Select',
    '_10015_LOAD_MORE': 'Load more'
};
